export function compareLuxonDates (a: any, b: any){
    return a.checkinUtc.toMillis() - b.checkinUtc.toMillis()
}